import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ensureSessionStart, trackPageView } from './utils/curatorAnalytics';

const TRACKING_ID = 'G-NHJQ7DTKVW';

export const initGA = () => {
  ReactGA.initialize(TRACKING_ID);
};

export const PageView = (path = window.location.pathname) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const Event = ({ category, action, label }) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

export function AnalyticsRouter() {
  const location = useLocation();

  useEffect(() => {
    ensureSessionStart(location.pathname);
    PageView(location.pathname);
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
